<template>
    <v-menu
        v-model="internal_menu_open"
        :left="left"
        offset-x
        tile
    >
        <template v-slot:activator="{ on }">
            <v-hover
                v-if="item.children"
                v-model="menu_open"
                close-delay="500"
            >
                <v-list-item
                    v-on="on"
                    :style="css_props"
                    :disabled="item.disabled"
                    @click="handle_click(item)"
                >
                    <v-icon
                        v-if="item.icon"
                        class="pr-2"
                        small
                    >
                        {{ item.icon }}
                    </v-icon>
                    <v-list-item-title>
                        {{ item.text }}
                    </v-list-item-title>
                    <v-icon
                        v-if="item.children"
                        style="margin-left: auto"
                        small
                    >
                        mdi-chevron-right
                    </v-icon>
                </v-list-item>
            </v-hover>
            <v-list-item
                v-else
                v-model="menu_open"
                :style="css_props"
                @click="handle_click(item)"
            >
                <v-icon
                    v-if="item.icon"
                    class="pr-2"
                    small
                >
                    {{ item.icon }}
                </v-icon>
                <v-icon
                    v-else-if="item.disabled"
                    class="pr-2"
                    small
                >
                    mdi-information-outline
                </v-icon>
                <v-list-item-content
                    class="content"
                    :class="{disabled: item.disabled, 'pl-6': !item.disabled && !item.icon}"
                >
                    <v-list-item-title>
                        {{ item.text }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                        v-if="item.disabled"
                    >
                        {{ issue(item) }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </template>


        <v-hover
            v-model="sub_menu_open"
            close-delay="500"
        >
            <v-list
                class="pa-0"
                dense
            >
                <v-list-item
                    v-for="(item, index) in item.children"
                    :key="index"
                    :style="css_props"
                    :disabled="item.disabled"
                    @click="handle_click(item)"
                >
                    <v-list-item-title class="pl-6">
                        {{ item.text }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-hover>

    </v-menu>
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import locale_mixin from "@/mixins/common/locale_mixin";

export default {
    name: "ItemActionMenuMenuSubItem",
    props: {
        item: {
            type: Object
        },
        index: {
            type: Number
        },
        position: {
            type: Object
        },
        css_props: {
            type: Object
        }
    },
    mixins: [locale_mixin],
    components: {},
    data() {
        return {
            menu_open: false,
            sub_menu_open: false,
        }
    },
    computed: {
        internal_menu_open: {
            get() {
                return this.menu_open || this.sub_menu_open
            },
            set(val) {
                this.menu_open = val
                this.sub_menu_open = val
            }
        },
        left() {
            const viewport_width = window.innerWidth
            return (this.position.x + 660) > viewport_width
        },
        ...mapGetters([]),
        ...mapState([]),
    },
    watch: {
        internal_menu_open(val) {
            if (val) this.$emit('index', val)
            this.$emit("index_list", val)
        }
    },
    methods: {
        handle_click(item) {
            if (item?.disabled) return this.$emit('issues', item)
            if (item?.children) return
            this.$emit('action', item)
        },
        issue(item) {
            const [issue] = item['condition_issues']
            return this.translate(issue)
        },
        ...mapActions([]),
    },
    beforeCreate() {
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    beforeUpdate() {
    },
    updated() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
}
</script>
<style scoped lang="sass">
.v-list-item
    min-height: 35px
    background-color: var(--background) !important
    cursor: pointer

.v-list-item:hover
    opacity: 0.75

.v-list-item::before
    display: none !important

.content
    max-width: 220px

.disabled
    opacity: 0.5
</style>